(function($) {

  	// DOM is fully loaded, safe to manipulate elements
  	$(function() {	

		document.querySelectorAll('.splide.parcel-image-slider').forEach(sliderEl => {

			new Splide(sliderEl, {
				type: 'fade',
				perPage: 1,
				arrows: false,
				pagination: false,
				rewind: true,
				autoplay: true,
				interval: 4000,
				pauseOnHover: false,
				speed: 800,				
			}).mount();

		});

		// FYKI - see animateSliderLogo() in assets/js/modules/template--front-page.js
		// 		  
		// 		  Why though.
		// 		  
		// 		  1. It's because the logo animation is NOT part of the Image Slider block 
		// 		     setup, even if the relevant PHP code is part of 
		// 		     acf-blocks/image-slider/image-slider.php - even in this file it's
		// 		     restricted with an is_front_page() check.
		// 		  
		// 		  2. This is public only - we generally don't use animations in the editor 
		// 		     display. 

		function initAnimateSliderLogo() {
			
			const triggerEl 	= document.querySelector('.trusler-block--image-slider'), 
				  logo 			= triggerEl.querySelector('.wrap--slider-logo');

			if ( !logo || !triggerEl ) {
				return;
			}

			const mm = gsap.matchMedia();

			// 3️⃣ State tracking
			let animationPlayed = false;

			// variables that change per breakpoint
			let transformStart, transformEnd;

			// 1️⃣ Define breakpoint-dependent values
			mm.add(
				{
					mobile: "(max-width: 640px)",
					desktop: "(min-width: 641px)"
				},
				(context) => {
					const { mobile, desktop } = context.conditions;
					transformStart = mobile
						? 'translate3d(calc(-50% - 100px), -50%, 0)'
						: 'translate3d(-100px, 0, 0)';
					transformEnd = mobile
						? 'translate3d(-50%, -50%, 0)'
						: 'translate3d(0, 0, 0)';

					// If animation already finished, update instantly
					if (animationPlayed) {
						gsap.set(logo, { transform: transformEnd });
					}
				}
			);	

			// 2️⃣ Timeline
			const tl = gsap.timeline({
				paused: true,
				defaults: {
					duration: 1,
					ease: 'power2.out'
				},
				onComplete: () => {
					animationPlayed = true;
				}
			});		

			// troubleshooting
			/*tl.eventCallback('onComplete', () => {
				console.log('Timeline completed');
				animationPlayed = true;
			});

			tl.eventCallback('onUpdate', () => {
				console.log('Progress:', tl.progress());
			});*/

			// 4️⃣ Initial state
			gsap.set(logo, {
				opacity: 0,
				visibility: 'hidden',
				transform: transformStart
			});

			// 5️⃣ Animation definition
			tl.to(logo, {
				opacity: 1,
				visibility: 'visible',
				transform: transformEnd
			});  

			// Viewport checks (at least 50% visible)
			const rect 				= triggerEl.getBoundingClientRect();
			const viewportHeight 	= window.innerHeight;

			// Calculate how much of the element is visible
			const visibleTop 		= Math.max(rect.top, 0);
			const visibleBottom 	= Math.min(rect.bottom, viewportHeight);
			const visibleHeight 	= visibleBottom - visibleTop;

			// Element's total height
			const elementHeight 	= rect.height;

			// Calculate ratio of visibility
			const visibilityRatio 	= visibleHeight / elementHeight;

			// Is at least 50% visible?
			const isInView 			= visibilityRatio >= 0.5;

			// Additional states for context
			const isAboveView 		= rect.bottom <= 0;
			const isBelowView 		= rect.top >= viewportHeight;

			// CASE 1: already in viewport on load → animate immediately
			if (isInView) {
				tl.play();
				return;
			}

			// CASE 2: NOT in viewport on load → animate when gets in viewport
			ScrollTrigger.create({
				start: 0,
				end: 'max',	
				onUpdate: playTheShow,
			});

			function playTheShow() {

				if (
						ScrollTrigger.isInViewport(triggerEl, 0.5) &&
						gsap.getProperty(logo, 'opacity') === 0
					) {
					tl.play();
				}

			}

		}

		initAnimateSliderLogo();			

	});

})(jQuery);